import { useState } from 'react';
import { Plural, Trans } from '@lingui/react/macro';
import api from 'util/api';
import { debounce } from 'lodash';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { uniq } from 'lodash';


function BulkAddNoteModal({alarms, close, dismiss}) {
  const [note, setNote] = useState();
  const [processing, setProcessing] = useState(false);

  async function addNote() {
    if (!note) return;
    setProcessing(true);
    const promises = uniq(alarms.map(alarm => alarm.deviceId)).map(deviceId => {
      return api(`/devices/notes`, {
        method: 'POST',
        body: JSON.stringify({
          noteText: note,
          deviceId: deviceId
        })
      });
    });

    Promise.allSettled(promises).then(close);
  }

  const handleChange = debounce(function (event) {
    setNote(event.target.value)
  }, 200);

  return (
    <I18nProvider i18n={i18n}>
      <header>
        <h3>
          <Plural value={alarms.length} one="Add Note to # Alarm" other="Add Note to # Alarms" />
        </h3>
      </header>
      <section>
        <ul className="form">
          <li>
            <label htmlFor="alarm-note"><Trans>Note</Trans></label>
            <textarea
              placeholder="Add note..."
              id="alarm-note"
              name="alarm-note"
              onChange={handleChange}
            />
          </li>
        </ul>
      </section>
      <footer>
        <button onClick={dismiss}><Trans>Cancel</Trans></button>
        <button
          className={`primary ${processing ? 'processing' : ''}`}
          onClick={addNote}
          disabled={!note?.length || processing}
        >
          <Trans>OK</Trans>
        </button>
      </footer>
    </I18nProvider>
  )
}

export default BulkAddNoteModal;
